import UJwt  from '../../core/jwt/UJwt'

const { jwt } = UJwt({})

export default jwt
